import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import { Button, Input, Select, Space } from "antd";
import { useRef, useState } from "react";
import K from "utilities/constants";
import { CandidateFieldLabel } from "../candidateFieldLabel/candidateFieldLabel";
import labelStyles from "../candidateFieldLabel/candidateFieldLabel.module.scss";
import { CandidateFieldValue } from "../candidateFieldValue/candidateFieldValue";

export const CandidateField = ({
  label,
  value,
  options,
  isEditable = false,
  disabled = false,
  onEdit,
  validateValue,
  required = false,
}) => {
  const [isEdit, setIsEdit] = useState(false);
  const [validationError, setValidationError] = useState(null);
  const inputRef = useRef(value);

  const handleSave = () => {
    const next = options
      ? inputRef.current
      : (inputRef.current ?? "").trim() || null;
    const error = validateValue?.(null, next) ?? null;
    if (error) {
      setValidationError(error);
      return;
    }
    setValidationError(null);
    const original = options ? value : (value ?? "").trim() || null;
    if (next !== original) {
      onEdit?.(next);
    }
    setIsEdit(false);
  };

  const handleCancel = () => {
    inputRef.current = value;
    setValidationError(null);
    setIsEdit(false);
  };

  if (isEdit) {
    return (
      <div>
        <CandidateFieldLabel required={required}>{label}</CandidateFieldLabel>
        {options ? (
          <Select
            defaultValue={value}
            options={options}
            style={{ width: "100%" }}
            status={validationError ? "error" : undefined}
            onChange={(val) => {
              inputRef.current = val;
            }}
          />
        ) : (
          <Input
            defaultValue={value ?? ""}
            style={{ width: "100%" }}
            status={validationError ? "error" : undefined}
            onChange={(e) => {
              inputRef.current = e.target.value;
            }}
          />
        )}
        {validationError && (
          <div className={labelStyles.errorMessage}>{validationError}</div>
        )}
        <div style={{ marginTop: 4 }}>
          <Button
            type="link"
            onClick={handleCancel}
            icon={<CloseCircleOutlined className="closeIcon" />}
          />
          <Button
            type="link"
            onClick={handleSave}
            icon={<CheckCircleOutlined className="checkIcon" />}
          />
        </div>
      </div>
    );
  }

  return (
    <div>
      <CandidateFieldLabel>{label}</CandidateFieldLabel>
      <Space size={4} style={{ minHeight: 24 }}>
        <CandidateFieldValue>
          {options
            ? options.find((o) => o.value === value)?.label ?? K.NullPlaceholder
            : value ?? K.NullPlaceholder}
        </CandidateFieldValue>
        {isEditable && !disabled && (
          <Button
            style={{ width: 16, height: 16 }}
            type="link"
            onClick={() => {
              inputRef.current = value;
              setIsEdit(true);
            }}
            icon={<i className="icon-edit" />}
          />
        )}
      </Space>
    </div>
  );
};
